export * from './components/Dialog/index';
export { Dialog as default } from './components/Dialog/index';
//# sourceMappingURL=Dialog.js.map